import { Link, Paper, Typography } from '@material-ui/core';
import type { CockpitDeliveryView } from '../model/cockpitViewModel';
import { CockpitSectionHead } from './CockpitSectionHead';
import { useCockpitStyles } from './cockpitStyles';

export interface DeliverySectionProps {
  delivery: CockpitDeliveryView | null;
}

const PullRequestLine = ({ delivery }: { delivery: CockpitDeliveryView }) => {
  if (delivery.pullRequestUrl) {
    return (
      <Typography>
        Pull request:{' '}
        <Link
          href={delivery.pullRequestUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {delivery.pullRequestReference}
        </Link>
      </Typography>
    );
  }
  if (delivery.pullRequestReference) {
    return (
      <Typography>
        Referência do pull request: {delivery.pullRequestReference}
      </Typography>
    );
  }
  return <Typography>Nenhum pull request foi reportado.</Typography>;
};

function commitsLabel(count: number): string {
  if (count <= 0) return '';
  return ` · ${count} commit${count === 1 ? '' : 's'}`;
}

/**
 * What the repository reported about the delivery (RN-COCK-04). Absent until
 * a pull request reference or a terminal outcome exists; the phase alone never
 * makes this section appear.
 */
export const DeliverySection = ({ delivery }: DeliverySectionProps) => {
  const classes = useCockpitStyles();
  if (!delivery) return null;
  return (
    <Paper
      component="section"
      className={classes.panel}
      aria-labelledby="delivery-title"
    >
      <CockpitSectionHead id="delivery-title" title="Entrega">
        {delivery.statusLabel}
        {commitsLabel(delivery.commitCount)}
      </CockpitSectionHead>
      <PullRequestLine delivery={delivery} />
    </Paper>
  );
};
